
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/my-account/wishlist",
      function () {
        return require("private-next-pages/my-account/wishlist/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/my-account/wishlist"])
      });
    }
  